var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:flex bg-gray-200 md:w-full"},[_c('div',{staticClass:"md:w-full md:px-32"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }